module.exports = __webpack_public_path__ + "images/anwbmijnpechpasbd535239e9dfe4c184ce089cbc67a216.png";